// FooterPubblico.jsx — visibile ai clienti
import React, { useEffect, useState } from "react";
import {
  FaInstagram, FaMapMarkerAlt, FaPhoneAlt,
  FaMobileAlt, FaWhatsapp, FaStar,
} from "react-icons/fa";
import { fetchRatingStats, submitUserRating } from "../utility/EndPointGoogleFirebase";

const FooterPubblico = () => {
  const [averageRating, setAverageRating] = useState(0);
  const [totalReviews, setTotalReviews]   = useState(0);
  const [isLoading, setIsLoading]         = useState(true);
  const [rating, setRating]               = useState(0);
  const [hoverRating, setHoverRating]     = useState(0);
  const [isRated, setIsRated]             = useState(false);

  useEffect(() => {
    fetchRatingStats()
      .then(s => { setAverageRating(s.averageRating); setTotalReviews(s.totalReviews); })
      .catch(() => { setAverageRating(5.0); setTotalReviews(0); })
      .finally(() => setIsLoading(false));
  }, []);

  const handleRate = async (val) => {
    if (isRated) return;
    setRating(val); setIsRated(true);
    const ok = await submitUserRating(val);
    if (ok) {
      setTimeout(() => fetchRatingStats().then(s => {
        setAverageRating(s.averageRating);
        setTotalReviews(s.totalReviews);
      }), 1000);
    }
  };

  const menuUrl      = "https://www.nuovoforno1966.it/menu";
  const whatsappUrl  = `https://wa.me/?text=${encodeURIComponent(`Ciao! Qui trovi il nostro menu: ${menuUrl} ⭐ Votaci, il tuo voto conta! ❤️`)}`;
  const instagramUrl = "https://www.instagram.com/nuovo_forno_dal_1966?igsh=MXVqYndzYngwc2lsYg==";
  const mapsUrl      = "https://www.google.com/maps/search/?api=1&query=Via+Europa+35+89046+Marina+di+Gioiosa+Ionica";

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400;0,500;1,400&display=swap');

        .fp-root {
          background: linear-gradient(180deg, #0f172a 0%, #0a0f1e 100%);
          color: #94a3b8;
          position: relative;
          overflow: hidden;
        }

        /* Decorative top border */
        .fp-root::before {
          content: '';
          display: block;
          height: 3px;
          background: linear-gradient(90deg, transparent, #f59e0b, #dc2626, #f59e0b, transparent);
        }

        /* Subtle background texture */
        .fp-root::after {
          content: '';
          position: absolute;
          inset: 0;
          background: radial-gradient(ellipse 80% 50% at 50% 0%, rgba(245,158,11,0.04) 0%, transparent 70%);
          pointer-events: none;
        }

        .fp-inner {
          position: relative; z-index: 1;
          max-width: 960px; margin: 0 auto;
          padding: 48px 24px 0;
        }

        /* ── Logo / Brand ── */
        .fp-brand {
          text-align: center;
          margin-bottom: 40px;
        }
        .fp-brand-name {
          font-family: 'Playfair Display', Georgia, serif;
          font-size: clamp(22px, 5vw, 32px);
          font-weight: 400; color: #f8fafc;
          letter-spacing: -0.01em; line-height: 1.2;
        }
        .fp-brand-sub {
          font-size: 11px; color: #475569;
          letter-spacing: 0.2em; text-transform: uppercase;
          margin-top: 6px;
        }
        .fp-brand-line {
          width: 40px; height: 1px;
          background: linear-gradient(90deg, transparent, #f59e0b, transparent);
          margin: 12px auto 0;
        }

        /* ── Rating section ── */
        .fp-rating {
          display: flex; flex-direction: column; align-items: center;
          gap: 20px; text-align: center;
          padding: 32px 20px;
          margin-bottom: 40px;
          background: rgba(255,255,255,0.02);
          border: 1px solid rgba(255,255,255,0.06);
          border-radius: 20px;
          backdrop-filter: blur(4px);
        }

        .fp-rating-top {
          display: flex; flex-direction: column; align-items: center; gap: 10px;
        }
        .fp-rating-label {
          font-size: 10px; font-weight: 700; color: #475569;
          text-transform: uppercase; letter-spacing: 0.16em;
        }
        .fp-avg-row {
          display: flex; align-items: center; gap: 16px;
          flex-wrap: wrap; justify-content: center;
        }
        .fp-stars-display { display: flex; gap: 5px; }
        .fp-avg-number {
          font-family: 'Playfair Display', Georgia, serif;
          font-size: 48px; font-weight: 400; color: #f8fafc;
          line-height: 1;
        }
        .fp-avg-details {
          display: flex; flex-direction: column; align-items: flex-start; gap: 2px;
          padding-left: 4px; border-left: 1px solid #1e293b;
        }
        .fp-avg-max { font-size: 13px; color: #475569; }
        .fp-avg-votes { font-size: 11px; color: #334155; }

        /* Divider */
        .fp-rating-sep {
          width: 100%; height: 1px;
          background: linear-gradient(90deg, transparent, #1e293b, transparent);
        }

        /* Vote section */
        .fp-vote {
          display: flex; flex-direction: column; align-items: center; gap: 12px;
        }
        .fp-vote-title {
          font-size: 15px; font-weight: 500; color: #e2e8f0;
        }
        .fp-vote-sub {
          font-size: 12px; color: #475569;
        }
        .fp-vote-stars {
          display: flex; gap: 12px; margin-top: 4px;
        }
        .fp-star-btn {
          background: none; border: none; padding: 4px;
          cursor: pointer; line-height: 0;
          transition: transform 0.15s;
        }
        .fp-star-btn:hover { transform: scale(1.25); }
        .fp-rated-msg {
          display: flex; align-items: center; gap: 8px;
          font-size: 14px; font-weight: 500; color: #4ade80;
          background: rgba(74,222,128,0.08);
          border: 1px solid rgba(74,222,128,0.2);
          padding: 10px 20px; border-radius: 30px;
          animation: fp-pulse 2.5s ease-in-out infinite;
        }
        @keyframes fp-pulse { 0%,100%{opacity:0.8;} 50%{opacity:1;} }

        /* ── Info grid ── */
        .fp-grid {
          display: grid;
          grid-template-columns: 1fr;
          gap: 32px;
          padding-bottom: 40px;
          border-bottom: 1px solid #1e293b;
        }
        @media (min-width: 600px) {
          .fp-grid { grid-template-columns: repeat(3, 1fr); }
        }

        .fp-col {
          display: flex; flex-direction: column; gap: 14px;
          align-items: center; text-align: center;
        }
        @media (min-width: 600px) {
          .fp-col:nth-child(1) { align-items: flex-start; text-align: left; }
          .fp-col:nth-child(2) { align-items: center;     text-align: center; }
          .fp-col:nth-child(3) { align-items: flex-end;   text-align: right; }
        }

        .fp-col-title {
          font-size: 10px; font-weight: 700; color: #f59e0b;
          text-transform: uppercase; letter-spacing: 0.16em;
          padding-bottom: 8px;
          border-bottom: 1px solid #1e293b;
          width: 100%; text-align: inherit;
        }

        .fp-link {
          display: flex; align-items: center; gap: 8px;
          font-size: 13px; color: #64748b; text-decoration: none;
          transition: color 0.2s; line-height: 1.5;
        }
        .fp-link:hover { color: #e2e8f0; }
        .fp-link svg { flex-shrink: 0; }

        .fp-address {
          font-size: 12px; color: #475569; line-height: 1.7;
        }

        .fp-social-row {
          display: flex; gap: 10px;
        }
        .fp-social-btn {
          width: 40px; height: 40px; border-radius: 12px;
          display: flex; align-items: center; justify-content: center;
          text-decoration: none;
          background: rgba(255,255,255,0.04);
          border: 1px solid rgba(255,255,255,0.08);
          transition: background 0.2s, transform 0.15s, border-color 0.2s;
        }
        .fp-social-btn:hover {
          background: rgba(255,255,255,0.08);
          transform: translateY(-2px);
          border-color: rgba(255,255,255,0.15);
        }

        /* ── Copyright ── */
        .fp-copy {
          text-align: center;
          padding: 20px 24px 24px;
          font-size: 11px; color: #1e293b;
          letter-spacing: 0.04em;
        }
        .fp-copy span { color: #334155; }
      `}</style>

      <footer className="fp-root">
        <div className="fp-inner">

          {/* ── Brand ── */}
          <div className="fp-brand">
            <div className="fp-brand-name">Nuovo Forno dal 1966</div>
            <div className="fp-brand-sub">Marina di Gioiosa Ionica</div>
            <div className="fp-brand-line" />
          </div>

          {/* ── Rating + Voto ── */}
          <div className="fp-rating">

            <div className="fp-rating-top">
              <span className="fp-rating-label">Valutazione clienti</span>
              {isLoading ? (
                <span style={{ fontSize: 13, color: "#334155" }}>Caricamento...</span>
              ) : (
                <div className="fp-avg-row">
                  <div className="fp-stars-display">
                    {[1,2,3,4,5].map(i => (
                      <FaStar key={i} size={22}
                        color={i <= Math.round(averageRating) ? "#f59e0b" : "#1e293b"}
                        style={{ filter: i <= Math.round(averageRating) ? "drop-shadow(0 0 4px #f59e0b66)" : "none" }}
                      />
                    ))}
                  </div>
                  <span className="fp-avg-number">{averageRating.toFixed(1)}</span>
                  <div className="fp-avg-details">
                    <span className="fp-avg-max">su 5.0</span>
                    <span className="fp-avg-votes">{totalReviews} voti</span>
                  </div>
                </div>
              )}
            </div>

            <div className="fp-rating-sep" />

            {/* Voto interattivo */}
            <div className="fp-vote">
              <span className="fp-vote-title">La tua opinione è importante!</span>
              {isRated ? (
                <div className="fp-rated-msg">
                  <FaStar size={16} color="#f59e0b" />
                  Grazie per il tuo voto di {rating} stelle!
                </div>
              ) : (
                <>
                  <span className="fp-vote-sub">Clicca per votare</span>
                  <div className="fp-vote-stars">
                    {[1,2,3,4,5].map(i => (
                      <button key={i} className="fp-star-btn"
                        onClick={() => handleRate(i)}
                        onMouseEnter={() => setHoverRating(i)}
                        onMouseLeave={() => setHoverRating(0)}>
                        <FaStar size={40}
                          color={i <= (hoverRating || rating) ? "#f59e0b" : "#1e293b"}
                          style={{
                            filter: i <= (hoverRating || rating)
                              ? "drop-shadow(0 0 8px #f59e0baa)"
                              : "none",
                            transition: "all 0.15s",
                          }}
                        />
                      </button>
                    ))}
                  </div>
                </>
              )}
            </div>
          </div>

          {/* ── Grid info ── */}
          <div className="fp-grid">

            {/* Contatti */}
            <div className="fp-col">
              <div className="fp-col-title">Contatti</div>
              <a href="tel:+393286872410" className="fp-link">
                <FaMobileAlt style={{ color: "#22c55e", fontSize: 15 }} />
                +39 328 687 2410
              </a>
              <a href="tel:+390964369497" className="fp-link">
                <FaPhoneAlt style={{ color: "#60a5fa", fontSize: 14 }} />
                +39 0964 369497
              </a>
            </div>

            {/* Dove siamo */}
            <div className="fp-col">
              <div className="fp-col-title">Dove siamo</div>
              <span className="fp-address">
                Via Europa 35<br />
                89046 Marina di Gioiosa Ionica (RC)
              </span>
              <a href={mapsUrl} target="_blank" rel="noopener noreferrer"
                className="fp-link" style={{ color: "#f59e0b" }}>
                <FaMapMarkerAlt size={14} /> Visualizza mappa
              </a>
            </div>

            {/* Social */}
            <div className="fp-col">
              <div className="fp-col-title">Seguici e condividi</div>
              <div className="fp-social-row">
                <a href={instagramUrl} target="_blank" rel="noopener noreferrer"
                  className="fp-social-btn" title="Instagram">
                  <FaInstagram size={18} style={{ color: "#ec4899" }} />
                </a>
                <a href={whatsappUrl} target="_blank" rel="noopener noreferrer"
                  className="fp-social-btn" title="Condividi su WhatsApp">
                  <FaWhatsapp size={18} style={{ color: "#22c55e" }} />
                </a>
              </div>
            </div>

          </div>
        </div>

        <div className="fp-copy">
          <span>© {new Date().getFullYear()} Nuovo Forno dal 1966, di Matteo Lupis — P.IVA 03242870800</span>
        </div>
      </footer>
    </>
  );
};

export default FooterPubblico;